import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import swal from 'sweetalert';
import { translate } from 'react-i18next';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import { print } from 'react-icons-kit/fa/print';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

const Config = require('../../../config');

class PrintList extends Component{
    constructor(props){
        super(props);

        this.getList = this.getList.bind(this);
        this.setTable = this.setTable.bind(this);
        this.onPrint = this.onPrint.bind(this);

        this.state = {
            columns:[
                {title: 'No.'},
                {title: 'No. Unidad'},
                {title: 'No. Comp.'},
                {title: 'Fec. Donación'},
                {title: 'Componente'},
                {title: 'Volumen'},
                {title: 'Grupo & RH'},
                {title: 'Fec. Caducidad'}
            ],
            list:[]
        }
    }

    componentDidMount(){
        this.getList();
    }

    getList(){
        this.props.waiting.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+'plasma_process/table/'+this.props.match.params.id,{
            method: 'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then(msg => 
                    swal('Error', msg, 'error')    
                );
            }
        }).then(response => {
            if(response !== undefined){
                var list = [];

                response.map((res)=>
                    list.push([
                        res.consecutive,
                        res.unit_number,
                        res.component_number,
                        moment(res.donation_date).format('DD/MM/YYYY'),
                        res.component,
                        res.volume,
                        res.g_rh,
                        moment(res.caducidad).format('DD/MM/YYYY')
                    ])
                )


                setTimeout(()=>{
                    this.props.waiting.handleShow('Cargando...');
                }, 500);

                setTimeout(()=>{
                    this.props.waiting.handleClose();
                    this.setTable();
                }, 1000);

                this.setState({
                    list: list,
                });
            }
        })
    }

    setTable(){
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: 'Impresión de Plasma a Industrializar'
            	}            	
            ],
			data: this.state.list,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

    }
    
    async onPrint(e){
		e.preventDefault();
		
		this.props.waiting.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.props.match.params.id;
		obj.file_type = 'plasma_process';
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({aux_id:""});
		}else{
			this.props.waiting.handleClose();
		}
	
		
	}

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Impresión de plasma
					</h5>
				</div>
                <div className="col-xs-12">
                    <div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold", fontSize:'18px'}}>
                        <span>
                           Impresión de plasma
                        </span>
                    </div>

                    <div className="col-xs-12 form-group" id="table-to-pdf">
                        <div className="table-responsive">

                            <table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" ref={el => this.el = el}>
                            </table>
                        </div>

                    </div>

                    <div className="col-xs-12" style={{textAlign:'center'}}>
                        <button type="button" tittle="" className="btn btn-results" 
							style={{background:'transparent'}}
							onClick={(e)=>this.onPrint(e)}>
							<div style={{textAlign:'center'}}>
								<SvgIcon icon={print} size={30}/>
							</div>
							Imprimir
						</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations') (PrintList);